import React from 'react'
import styles from "./curljungdebates.module.css";
import { Box, Link, Modal, Typography } from "@mui/material";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Head from "next/head";
import MysteryBannerNew from '../../components/MysteryBannerNew/MysteryBannerNew';

function Index() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [newOpen, setNewOpen] = useState(false);

  const handleNewOpen = () => setNewOpen(true);
  const handleNewClose = () => setNewOpen(false);

  return (
    <>

    <Head>
      <title>CURL JUNG DEBATES | School of Our Divine Infinite Being</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
        <meta name="keywords" content="Carl Jung, Alfred Curl, psychology debates, depth psychology, spirituality and psychology, Jungian theory, spiritual awakening, consciousness studies, holistic psychology, Curl-Jung discussions, Divine Infinite Being project, mental health and spirituality, archetypes, psyche and soul, psychological integration."></meta>
      <meta name="description" content="Discover the diverse influences that shape the philosophy and teachings of the School of Divine Infinite Being, featuring a wide array of philosophers, physicists, psychologists, and spiritual leaders."></meta>

      <meta property="og:title" content="CURL JUNG DEBATES | School of Our Divine Infinite Being"></meta>
      <meta property="og:description" content="Discover the diverse influences that shape the philosophy and teachings of the School of Divine Infinite Being, featuring a wide array of philosophers, physicists, psychologists, and spiritual leaders."></meta>
      <meta property="og:url" content="https://www.divineinfinitebeing.com/curl-jung-debates"></meta>
      <meta property="og:type" content="website"></meta>
      <meta property="og:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/carl_jung_debates_og_img.webp"></meta>
      <meta property="og:image:alt" content="A collage of influential figures in philosophy, science, and spirituality"></meta>

      <meta property="twitter:card" content="summary_large_image"></meta>
      <meta property="twitter:title" content="CURL JUNG DEBATES | School of Our Divine Infinite Being"></meta>
      <meta property="twitter:description" content="Discover the diverse influences that shape the philosophy and teachings of the School of Divine Infinite Being, featuring a wide array of philosophers, physicists, psychologists, and spiritual leaders."></meta>
      <meta property="twitter:url" content="https://www.divineinfinitebeing.com/curl-jung-debates"></meta>
      <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/carl_jung_debates_og_img.webp"></meta>
      <meta property="twitter:image:alt" content="Explore the rich tapestry of intellectual and spiritual influences at the School of Divine Infinite Being"></meta>
      <link rel="canonical" href="https://www.divineinfinitebeing.com/curl-jung-debates" />
 
    </Head>




    <div className={styles.curl_jung_debates_page_main}>

      <div className={styles.curl_jung_debates_blockone}>
        {/* {/ <!------Main Banner section-------> /} */}
        <div className={styles.curl_jung_debates_banner_main_wrpr}>
          <div className={styles.curl_jung_debates_banner_left}>
            <div className={styles.bannerLogo}>
              <span className={styles.logoviewlink} onClick={handleOpen}>
                <img src={`${process.env.cloud_url2}assets/images/viewicon.png`}/>
              </span>
              <img src={`${process.env.cloud_url2}assets/images/logobanner.webp`}/>
            </div>
            <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
            <h1 data-text="infinite being">INFINITE BEING</h1>

            <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
            <div className={`${styles.curl_jung_debates_bottombannerbg} ${styles.bannerboxtxt}`}>
              <div className={styles.yellow_bar}></div>
            </div>
            <div className={styles.banr_page_title_sec}>
              <h3>Carl Jung  Debates</h3>
            </div>
          </div>
        </div>
      </div>

      <MysteryBannerNew/>

      <div className={styles.curl_jung_debates_block_sec_main}>

        <div className={styles.common_width}>
          <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
            <div className={styles.column}>
              <div className={`${styles.col12} ${styles.bgifive}`}>
                <h1>Debates with Carl Jung and different prominent athiests</h1>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.curl_jung_debates_block1_main_width}>
          <div className={styles.common_width_b}>
            <div className={`${styles.curl_jung_debates_block1_wrp} ${styles.wrpr_left}`}>
              <div className={styles.curl_jung_debates_cont_box}>
                <p>Many modern scholars have argued for the Jungian position in opposition to secular atheism, such as the very famous Jordan Peterson. </p>

                <p>Although Jung died June 6, 1961 and has the disadvantage of 7 decades of continuing scientific development, we wanted to resurrect his position on the value of Religion and belief in God.  In our opinion the modern debate forum arguing with mostly biblical religious dogma as a background misses a profound position that Jung championed throughout his career.</p>

                <p>These debates were created from a neutral position giving equal credence to both sides of the argument. They were generated by agnostic rules in Chat GPT 4 and include both creative scripts and actual statements from each of the debaters' written work. These do not reflect actual historical debates but are overall a creative work giving the audience the opportunity to consider both sides in their own journeys towards truth.</p>

                <p>For implications of Jung’s theories in the light of a modern frame, especially concerning the work started with his colleague and Nobel prize winning quantum physicist Worlfgang Pauli, current ideas in string theory, perennial philosophy and religious studies please consider reviewing our <span><Link href="/central-doctrine">central doctrine</Link></span> at <span><Link href="https://www.divineinfinitebeing.com/">www.divineinfintebeing.com</Link></span>.</p>
              </div>

              <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/curl_jung_debates/jung_debates_block1_left_img.webp'></img>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div className={styles.curl_jung_debates_block2_main}>
        <div className={styles.common_width_b}>
          <div className={styles.curl_jung_debates_block2_main_wrpr}>

            <div className={styles.jung_debates_block2_skyblue_full_box}>
              <div className={styles.jung_debates_block2_skyblue_box_sub}>
                <div className={styles.jung_debates_block2_skyblue_vdo_sec}>
                  {/* <iframe width="560" height="315" src="https://www.youtube.com/embed/2AMu-G51yTY?si=MLMNFZce6_bKTi05" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}
                  <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/curl_jung_debates/jung_debates_block2_vdo_img.webp'></img>
                </div>

                <div className={styles.jung_debates_block2_vdo_heading_sec}>
                  <h2>CARL JUNG  WITH Christopher Hitchens</h2>
                </div>
              </div>
            </div>

            <div className={styles.jung_debates_block2_skyblue_full_box}>
              <div className={styles.jung_debates_block2_skyblue_box_sub}>
                <div className={styles.jung_debates_block2_skyblue_vdo_sec}>
                  {/* <iframe width="560" height="315" src="https://www.youtube.com/embed/2AMu-G51yTY?si=MLMNFZce6_bKTi05" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}
                  <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/curl_jung_debates/jung_debates_block2_vdo_img.webp'></img>
                </div>

                <div className={styles.jung_debates_block2_vdo_heading_sec}>
                  <h2>CaRL JUNG  WITH Richard Dawkins</h2>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>




      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="banner_modal_main"
      >
        <Box className="banner_modal_box">
          <Typography
            id="modal-modal-description" component="div"
            sx={{ mt: 2 }}
            className="modal_banner"
          >
            <div className="sub_modal_banner">
              <span className="close_btn" onClick={handleClose}>
                <CloseIcon />
              </span>
              <img
                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                alt="bannerLogo"
              />
            </div>
          </Typography>
        </Box>
      </Modal>


      <Modal
        open={newOpen}
        onClose={handleNewClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="banner_modal_main"
      >
        <Box className="banner_modal_box_new">
          <Typography
            id="modal-modal-description" component="div"
            sx={{ mt: 2 }}
            className="modal_banner_new"
          >
            <div className="sub_modal_banner">
              <span className="close_btn" onClick={handleNewClose}>
                <CloseIcon />
              </span>
              <img
                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                alt="bannerLogo"
              />
              <p className="modal_commingsoon">Coming soon</p>
            </div>
          </Typography>
        </Box>
      </Modal>

    </div>



    <div className={styles.curl_jung_debates_page_demo}>
        {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/curl_jung_debates/divine_curl_jung_debates_page_banner_img.webp'></img> */}
        {/* <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/curl_jung_debates/divine_curl_jung_debates_page_block1%2C2_img.webp'></img> */}
    </div>

    </>
  )
}

export default Index
